<template>
  <div>
    <div
      v-if="!hasMore"
      class="tw-border-b tw-px-20 tw-py-2 tw-text-xs tw-italic tw-text-gray-400"
    >
      Einde bereikt
    </div>

    <loading-icon v-if="showLoadingIcon" />

    <c-button
      v-if="showTriggerButton"
      @click="loadMore"
      :disabled="isLoading"
      :label="loadingLabel"
    />

    <div v-else-if="showAutoTrigger" ref="autoTrigger" />
  </div>
</template>

<script setup>
import {
  computed,
  nextTick,
  onMounted,
  onUnmounted,
  useTemplateRef,
} from "vue";
import LoadingIcon from "components/loaders/LoadingIcon.vue";

const props = defineProps({
  trigger: { type: String, default: "button" },
  loadMore: { type: Function, required: true },
  isLoading: { type: Object, required: true },
  hasMore: { type: Object, required: true },
});

const autoTrigger = useTemplateRef("autoTrigger");
let observer = null;

// Computed
const showLoadingIcon = computed(() => {
  return props.trigger === "auto" && props.isLoading;
});

const showTriggerButton = computed(
  () => props.trigger === "button" && props.hasMore,
);

const loadingLabel = computed(() =>
  props.isLoading ? "Laden..." : "Meer laden...",
);

const showAutoTrigger = computed(
  () => props.trigger === "auto" && props.hasMore,
);

onMounted(async () => {
  if (props.trigger === "auto" && autoTrigger.value) {
    await nextTick();
    observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        if (entry.isIntersecting && props.hasMore && !props.isLoading) {
          props.loadMore();
        }
      },
      {
        threshold: 1.0,
      },
    );

    if (autoTrigger.value) {
      observer.observe(autoTrigger.value);
    }
  }
});

onUnmounted(() => {
  if (observer && autoTrigger.value) {
    observer.unobserve(autoTrigger.value);
  }
});
</script>
